import { toast } from 'react-hot-toast';
import { useMutation } from 'react-query';

import { SanitizedEntityParams, createEntity } from '@utils/backend-api/entities';

export default function useEntitiesCreate(silenceToast = false) {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    async (values: SanitizedEntityParams) => await createEntity(values),
    {
      onError: (_err, _variables, _context) => {
        !silenceToast && toast.error(`Something Went Wrong`);
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
}
